<script>
import { mapState } from 'vuex';
import AthleteFinancialsContent from '@components/global/AthleteFinancialsContent.vue';

// Standalone financials sidebar (opened via the financialsPanel store from
// the athlete profile). The actual view lives in AthleteFinancialsContent,
// which is also embedded in the event panel's Οικονομικά view. close()
// always nulls athleteId, so reopening remounts the content and refetches.
export default {
  name: 'AthleteFinancialsPanel',
  components: { AthleteFinancialsContent },

  computed: {
    ...mapState('financialsPanel', ['athleteId']),
    isOpen: {
      get() {
        return !!this.athleteId;
      },
      set(val) {
        if (!val) this.$store.dispatch('financialsPanel/close');
      },
    },
  },
};
</script>

<template>
  <app-side-panel v-model="isOpen"
                  :title="$t('financials.panelTitle')"
                  width="640px"
                  sidebar-id="athlete-financials-sidebar"
                  panel-class="athlete-financials-panel"
  >
    <template #icon><i class="fe-calendar"></i></template>

    <athlete-financials-content v-if="athleteId" :athlete-id="athleteId" />
  </app-side-panel>
</template>
